export default __webpack_public_path__ + "static/media/mens_casual_shirt.96bf6464.glb";